"use client";

import Link from "next/link";

/**
 * Error boundary for every /blog route.
 *
 * Reached when WordPress cannot be read (BlogSourceUnavailableError). The distinction
 * from not-found.jsx is the whole point: a missing post is a 404, an unreachable CMS is
 * a 500. Serving 404 here would invite Google to deindex live articles.
 */
export default function BlogError({ error, reset }) {
  return (
    <main className="flex min-h-[50vh] w-full flex-col items-center justify-center gap-4 bg-black px-6 text-center text-white">
      <h1 className="text-2xl font-bold">The blog is temporarily unavailable</h1>
      <p className="max-w-[460px] text-white/60">
        We could not load this page right now. This is usually brief — please try again
        in a moment.
      </p>

      {process.env.NODE_ENV !== "production" && error?.message ? (
        <pre className="max-w-[640px] overflow-x-auto rounded-lg bg-white/5 px-4 py-3 text-left text-xs text-white/50">
          {error.message}
        </pre>
      ) : null}

      <div className="mt-2 flex items-center gap-3">
        <button
          type="button"
          onClick={reset}
          className="rounded-full bg-themeColor px-5 py-2.5 text-sm font-semibold text-black transition-opacity hover:opacity-90"
        >
          Try again
        </button>
        <Link
          href="/"
          className="rounded-full border border-white/15 px-5 py-2.5 text-sm font-semibold text-white/80 transition-colors hover:border-white/30"
        >
          Go home
        </Link>
      </div>
    </main>
  );
}
